import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';

import main from '../reducers/main';
import personas from '../reducers/personas';
import autorizacionViaje from '../reducers/autorizacionViaje';
import contraventores from '../reducers/contraventores';
import expediente from '../reducers/expediente';
import pedido from '../reducers/pedido';
import detalles from '../reducers/detalles';
import busquedaExpedientes from '../reducers/busquedaExpedientes';
import keycloak from '../reducers/keycloak';

export default function configureStore() {
  const store = createStore(
    combineReducers({
      main,
      personas,
      autorizacionViaje,
      contraventores,
      expediente,
      pedido,
      busquedaExpedientes,
      detalles,
      keycloak,
    }),
    applyMiddleware(thunk)
  );

  return store;
}
